// helper/regex.ts - Funções para manipulação de strings usando regex
export const tagRegExp = /<(\"[^\"]*\"|'[^']*'|[^'\">])*>/

/**
 * Valida se a string é uma email válido
 * @param email - String com possivel email
 */
export const isEmail = (email:string) => new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}').test(email)

/**
 * Extrai tag html por nome da tag
 * @param tag - Nome da tag
 * @param html - Html onde sera extraida a tag
 */
export const tagRegExpByName = (tag:string, html:string) => new RegExp(`\\<${tag}\\>([\\s\\S]+?)\\<\\/${tag}>`, 'g').exec(html)

/**
 * Obtem tag htnl pelo nome da class
 * @param cls - Nome da classe
 * @param tag - Nome da tag
 * @param html - Html onde sera extraida a tag
 */
export const getTagClass = (tag:string,cls:string,html:string) => {
    return new RegExp("<" + tag + "[^>]*class[\\s]?=[\\s]?['\"]" + cls + "[^'\"]*['\"][\\s\\S]*?<\/" + tag + ">").exec(html)
}

/**
 * Obtem uma tag html por id
 * @param tag 
 * @param id 
 * @param html 
 */
export const getTagId = (tag:string,id:string,html:string) => {
    return new RegExp("<" + tag + "[^>]*id[\\s]?=[\\s]?['\"]" + id + "['\"][\\s\\S]*?<\/" + tag + ">").exec(html)
}

/**
 * Obtem as duas primeiras palavras de uma string 
 * @param word - string qualquer
 */
export const getFirstTwoWords = (word:string) => {
    var matches = word.match(/([\w+]+)/g)
    return `${matches[0]} ${matches[1] ? matches[1] : ''}`
}

/**
 * Obtem as somente as primeiras letras de cada palavra em uma string
 * @param word - string qualquer
 */
export const getFirstLetterOfEachWord = (word:string) => {
    var matches = word.match(/\b(\w)/g)
    return matches.join(' ')
}

/**
 * 1 - Se o text contém apenas espaços em branco, retorna uma string vazia
 * 2 - Caso contrário, remove os espaços em branco no início e no final
 * @param text - string qualquer
 */
export const removeFinalSpaces = (text: string) => {
    if (text.match(/^\s*$/) !== null) {
      // 1
      return ''
    } else {
      // 2
      return text.trim()
    }
  }